import { Actions as OrganizationActions } from '../actions/organization';
import { Actions as UpdateOrganizationActions } from '../actions/updateOrganization';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IOrganization } from '../interfaces/organization';

export type State = DeepReadonly<{
  isFetching: boolean;
  organization: IOrganization | null;
  ssqId: string | null;
  fetchError: AxiosError | Error | null;
  updateError: AxiosError | Error | null;
}>;

export type Actions = OrganizationActions | UpdateOrganizationActions;

export const initialState: State = {
  isFetching: false,
  organization: null,
  ssqId: null,
  fetchError: null,
  updateError: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_ORGANIZATION_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_ORGANIZATION_SUCCESS':
    case 'UPDATE_ORGANIZATION_SUCCESS':
      return {
        isFetching: false,
        organization: action.payload,
        fetchError: null,
        updateError: null,
        ssqId: action.ssqId
      };
    case 'FETCH_ORGANIZATION_FAILURE':
      return {
        ...state,
        isFetching: false,
        fetchError: action.error
      };
    case 'UPDATE_ORGANIZATION_FAILURE':
      return {
        ...state,
        isFetching: false,
        updateError: action.error
      };
    default:
      return state;
  }
}
